import notification from '@/api/notification-monitoring'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  edit_data: {},
  notification_types: [],
  selected_notification_type: null
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_EDIT_DATA(state, data) {
    state.edit_data = data
  },
  SET_NOTIFICATION_TYPES(state, data) {
    state.notification_types = data
  },
  SET_SELECTED_NOTIFICATION_TYPE(state, id) {
    state.selected_notification_type = id
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        not_type_id: context.state.selected_notification_type
      },
      attrubutes
    )
    return notification.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  async dataBeforeCreate(context) {
    if (!context.state.notification_types.length > 0) {
      let response = await notification.notificationTypes()
      context.commit('SET_NOTIFICATION_TYPES', response)
    }
  }
}
